import { FiPhone } from "react-icons/fi";
import { TiStarburst } from "react-icons/ti";

const BusinessAddress = () => {
  return (
    <div className="mt-16 w-[1018px]">
      <table className="flex w-[1018px] justify-between ">
        <tr className="flex flex-col gap-y-8">
          <td className="font-pop text-2xl font-semibold text-darkGreen">
            Mobile
          </td>
          <td className="font-pop text-2xl font-semibold text-darkGreen">
            Land-line
          </td>
          <td className="font-pop text-2xl font-semibold text-darkGreen">
            City
          </td>
          <td className="font-pop text-2xl font-semibold text-darkGreen">
            Suburb
          </td>
          <td className="font-pop text-2xl font-semibold text-darkGreen">
            Address
          </td>
          {/* <td>
            <div className="flex items-center gap-x-3 ">
              <FiPhone className="h-6 w-6 text-secondary" />
              <p className="font-pop text-xl font-semibold">+2</p>
              <p className="flex items-center">
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
              </p>
            </div>
          </td> */}
          {/* <td>
            <button className="rounded-md bg-primary py-2.5 px-20 font-pop text-xs font-bold text-white">
              Show number
            </button>
          </td> */}
        </tr>
        <tr className="flex flex-col gap-y-[36px]">
          <td>
            <div className="flex items-center gap-x-3 ">
              <FiPhone className="h-6 w-6 text-secondary" />
              <p className="font-pop text-xl font-semibold">+2</p>
              <p className="flex items-center">
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
              </p>
            </div>
          </td>
          <td>
            <div className="flex items-center gap-x-3 ">
              <FiPhone className="h-6 w-6 text-secondary" />
              <p className="font-pop text-xl font-semibold">+2</p>
              <p className="flex items-center">
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
                <TiStarburst />
              </p>
            </div>
          </td>
          <td className="font-regular font-pop text-xl text-black text-opacity-70">
            Perth
          </td>
          <td className="font-regular font-pop text-xl text-black text-opacity-70">
            Caning Vale 1665
          </td>
          <td className="font-regular font-pop text-xl text-black text-opacity-70">
            21 Scott avenue
          </td>
        </tr>
        <tr className="flex flex-col gap-y-7">
          <td>
            <button className="rounded-md bg-primary py-2.5 px-20 font-pop text-xs font-bold text-white">
              Show number
            </button>
          </td>
          <td>
            <button className="rounded-md bg-primary py-2.5 px-20 font-pop text-xs font-bold text-white">
              Show number
            </button>
          </td>
        </tr>
      </table>
    </div>
  );
};

export default BusinessAddress;
